export const CATEGORIES = {
  PUBLIC_MESSAGE: 'Public Message',
  PRIVATE_MESSAGE: 'Private Message',
  POLLS: 'Polls',
  AD_BANNER: 'Ad Banner'
}
